import * as gqlTypes from './graphql-types';

export type Account = gqlTypes.upsells_accountFragment;

export enum BillingInterval {
  month = 'month',
  year = 'year',
}

export type CurrenciesQuery = gqlTypes.upsells_currenciesQuery;
export type Currency = gqlTypes.upsells_currenciesQuery_currencies;
export type CurrentAccountQuery = gqlTypes.upsells_currentAccountQuery;
export type CurrentUserQuery = gqlTypes.upsells_currentUserQuery;
export type ExtendTrialMutation = gqlTypes.upsells_extendTrialMutation;
export type FeatureEnrollment = gqlTypes.upsells_accountFragment_featureEnrollmentList;
export type Interval = 'month' | 'year';
export type IsAuthenticatedQuery = gqlTypes.upsells_isAuthenticatedQuery;
export type MemberRole = gqlTypes.MemberRole;
export type NextPlanQuery = gqlTypes.upsells_nextPlanQuery;
export type PaymentSourceQuery = gqlTypes.upsells_paymentSourceQuery;
export type Plan = gqlTypes.upsells_planFragment;
export type PlanStack = gqlTypes.upsells_planStacksQuery_planStacks;
export type PlanStacksQuery = gqlTypes.upsells_planStacksQuery;
export type PlanType = 'Free' | 'Starter' | TrialType;
export type Size = 'large' | 'medium' | 'small';
export type TrialType = 'Professional' | 'Team' | 'Company';

export const upgradeReasons: {
  [x: string]: UpgradeReason;
} = {
  emailSupport: 'email-support',
  multistep: 'multistep',
  paths: 'paths',
  premium: 'premium',
  premiumLimit: 'premium-limit',
  taskLimit: 'tasks',
  taskLimitLow: 'tasks-low',
  zapLimit: 'live-zaps',
};

export type UpgradeReason =
  | 'email-support'
  | 'live-zaps'
  | 'multistep'
  | 'paths'
  | 'premium'
  | 'premium-limit'
  | 'tasks'
  | 'tasks-low';

export const trialExtensionReasons: {
  [x: string]: string;
} = {
  emailSupport: 'email-support',
  multistep: 'multistep',
  paths: 'paths',
  premium: 'premium',
  premiumLimit: 'premium-limit',
  taskLimit: 'tasks',
  unknown: 'unknown',
  zapLimit: 'live-zaps',
};

export type TrialExtensionReason =
  | 'email-support'
  | 'live-zaps'
  | 'multistep'
  | 'paths'
  | 'premium'
  | 'premium-limit'
  | 'tasks'
  | 'unknown';

// Loosely typed types to support dynamic `useQuery` and `useMutation`.
export type OperationVariables = Record<string, any>;

export type QueryResult<Data = any> = {
  called: boolean;
  client: any;
  data: Data;
  error?: any;
  loading: boolean;
  networkStatus: any;
  refetch: () => void;
};
type TData = any;

export type UseQuery = (query: any, opts?: {}) => QueryResult;

type MutationOptions = {};
type FetchResult<TData = {}> = {
  data?: TData | null;
  extensions?: any;
  context?: any;
};

type MutateFunction<TData> = (
  opts: MutationOptions
) => Promise<FetchResult<TData>>;

export type MutationResult<TData> = Partial<QueryResult<TData>>;

export type UseMutation = (
  query: any,
  opts?: {}
) => [MutateFunction<TData>, MutationResult<TData>];

export type ApolloInjection = {
  useMutation?: UseMutation;
  useQuery?: UseQuery;
};
